export const DISTRICTS = [
  { id: 1, name: "Colombo" },
  { id: 2, name: "Gampaha" },
  { id: 3, name: "Kalutara" },
  { id: 4, name: "Kandy" },
  { id: 5, name: "Matale" },
  { id: 6, name: "Nuwara Eliya" },
  { id: 7, name: "Galle" },
  { id: 8, name: "Matara" },
  { id: 9, name: "Hambantota" },
  { id: 10, name: "Jaffna" },
  { id: 11, name: "Kilinochchi" },
  { id: 12, name: "Mannar" },
  { id: 13, name: "Vavuniya" },
  { id: 14, name: "Mullaitivu" },
  { id: 15, name: "Batticaloa" },
  { id: 16, name: "Ampara" },
  { id: 17, name: "Trincomalee" },
  { id: 18, name: "Kurunegala" },
  { id: 19, name: "Puttalam" },
  { id: 20, name: "Anuradhapura" },
  { id: 21, name: "Polonnaruwa" },
  { id: 22, name: "Badulla" },
  { id: 23, name: "Monaragala" },
  { id: 24, name: "Ratnapura" },
  { id: 25, name: "Kegalle" },
];

export const DEFAULT_DISTRICT = "1";

export const partnerNameOptions = (partnerNames = []) => {
  const seenNames = new Set();

  return partnerNames
    .reduce((options, partnerName) => {
      const name = String(partnerName || "");
      const normalizedName = name.toLocaleLowerCase();

      if (!name || seenNames.has(normalizedName)) {
        return options;
      }

      seenNames.add(normalizedName);
      return [...options, { value: name, label: name }];
    }, [])
    .sort((first, second) => first.label.localeCompare(second.label));
};

export const PARTNER_FEATURES = [
  {
    type: "medicine",
    label: "Medicine",
    subtypes: [
      { value: "order_now", label: "Order Now" },
      { value: "pickup", label: "Pickup" },
      { value: "delivery", label: "Delivery" },
    ],
  },
  // {
  //   type: "consultation",
  //   label: "Consultation",
  //   subtypes: [
  //     { value: "online_consultation", label: "Online Consultation" },
  //     { value: "offline_consultation", label: "Offline Consultation" },
  //   ],
  // },
  {
    type: "lab",
    label: "Lab",
    subtypes: [
      { value: "home labs", label: "Home Labs" },
      { value: "walk in labs", label: "Walk In Labs" },
    ],
  },
];

export const districtNameById = (id) => {
  const district = DISTRICTS.find((item) => String(item.id) === String(id));
  return district ? district.name : "";
};

export const EMPTY_PARTNER = {
  name: "",
  branchName: "",
  district: DEFAULT_DISTRICT,
  coordinates: "",
  latitude: "",
  longitude: "",
  mobile: "",
  logo: "",
  isInactive: false,
  quoteAvailable: true,
  partnerFeatures: [],
};

export const togglePartnerFeatureType = (partner, type, enabled) => {
  const partnerFeatures = partner.partnerFeatures || [];

  if (enabled) {
    if (partnerFeatures.some((feature) => feature.type === type)) {
      return partner;
    }

    return {
      ...partner,
      partnerFeatures: [...partnerFeatures, { type, subtypes: [] }],
    };
  }

  return {
    ...partner,
    partnerFeatures: partnerFeatures.filter((feature) => feature.type !== type),
  };
};

export const togglePartnerFeatureSubtype = (
  partner,
  type,
  subtype,
  enabled,
) => ({
  ...partner,
  partnerFeatures: (partner.partnerFeatures || []).map((feature) => {
    if (feature.type !== type) return feature;

    const subtypes = feature.subtypes || [];
    return {
      ...feature,
      subtypes: enabled
        ? Array.from(new Set([...subtypes, subtype]))
        : subtypes.filter((value) => value !== subtype),
    };
  }),
});

export const normalizePartnerFeatures = (features) => {
  if (!Array.isArray(features)) return [];

  return features.reduce((normalized, feature) => {
    if (!feature || typeof feature.type !== "string" || !feature.type) {
      return normalized;
    }

    const subtypes = Array.isArray(feature.subtypes)
      ? feature.subtypes.filter(
          (subtype, index, values) =>
            typeof subtype === "string" &&
            subtype.length > 0 &&
            values.indexOf(subtype) === index,
        )
      : [];
    const existing = normalized.find((item) => item.type === feature.type);

    if (existing) {
      existing.subtypes = Array.from(
        new Set([...existing.subtypes, ...subtypes]),
      );
      return normalized;
    }

    return [...normalized, { type: feature.type, subtypes }];
  }, []);
};

export const updatePartnerField = (partner, name, value) => {
  if (name !== "coordinates") {
    return { ...partner, [name]: value };
  }

  const [latitude = "", longitude = ""] = value.split(",");
  return {
    ...partner,
    coordinates: value,
    latitude: latitude.trim(),
    longitude: longitude.trim(),
  };
};

export const validatePartner = (partner) => {
  const errors = {};

  ["name", "branchName", "district", "coordinates", "mobile"].forEach(
    (name) => {
      if (!(partner[name] || "").trim()) {
        errors[name] = "This field is required.";
      }
    },
  );

  if (!partner.logo) {
    errors.logo = "Partner logo is required.";
  }

  if (partner.mobile && !/^[0-9]{9}$/.test(partner.mobile.replace(/\s/g, ""))) {
    errors.mobile = "Enter a valid 9-digit mobile number.";
  }

  if (
    partner.coordinates &&
    (!partner.coordinates.includes(",") ||
      !partner.latitude ||
      !partner.longitude ||
      !Number.isFinite(Number(partner.latitude)) ||
      !Number.isFinite(Number(partner.longitude)))
  ) {
    errors.coordinates =
      "Enter both latitude and longitude separated by a comma.";
  }

  return errors;
};

export const partnerFromApi = (partner) => {
  const mobile = String(partner.mobile_number || "").replace(/\D/g, "");
  const latitude =
    partner.latitude === null || partner.latitude === undefined
      ? ""
      : String(partner.latitude);
  const longitude =
    partner.longitude === null || partner.longitude === undefined
      ? ""
      : String(partner.longitude);
  const district = DISTRICTS.find(
    (item) =>
      String(item.id) === String(partner.branch) ||
      item.name.toLowerCase() === String(partner.district || "").toLowerCase(),
  );

  return {
    ...EMPTY_PARTNER,
    name: partner.partner_name || "",
    branchName: partner.branch_name || "",
    district: district ? String(district.id) : DEFAULT_DISTRICT,
    mobile: mobile.indexOf("94") === 0 ? mobile.slice(2) : mobile,
    coordinates: latitude && longitude ? latitude + ", " + longitude : "",
    latitude,
    longitude,
    logo: partner.logo || "",
    quoteAvailable:
      partner.quote_available !== false &&
      partner.quote_available !== 0 &&
      partner.quote_available !== "0",
    isInactive:
      partner.is_active === false ||
      partner.is_active === 0 ||
      partner.is_active === "0",
    partnerFeatures: normalizePartnerFeatures(partner.partner_features),
  };
};

export const openGoogleMaps = () => {
  window.open(
    "https://www.google.com/maps",
    "GoogleMaps",
    "width=1000,height=750",
  );
};
